import React from 'react';
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
class Train extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/EcosphereDetails/Trainbanner.png"), imgHDPath: `${require("img/EcosphereDetails/Trainbanner.png")} 1x,${require("img/EcosphereDetails/Trainbanner@2x.png")} 2x,${require("img/EcosphereDetails/Trainbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists: [
        {
          title: '工程管理岗位技能培训',
          data: '面向工程行业广大应届毕业生及需要专业提升的职场人，针对BIM应用、造价与招采管理、工程审计等专业岗位开展培训。提升学员的专业能力，达到职业需求，成为学员与用人单位间的纽带与桥梁。',
          imgPath: require("img/EcosphereDetails/Trainicon01.png"), imgHDPath: `${require("img/EcosphereDetails/Trainicon01.png")} 1x,${require("img/EcosphereDetails/Trainicon01@2x.png")} 2x,${require("img/EcosphereDetails/Trainicon01@3x.png")} 3x`
        },
        {
          title: '知识分享',
          data: '帮助企业构建学习平台，丰富工程管理相关专业课程资源；支持实现多层次、多专业的分级管理；多元的学习入口，场景化运营渗透，O2O专业服务支持，全面加速企业人才培养和绩效转化。',
          imgPath: require("img/EcosphereDetails/Trainicon02.png"), imgHDPath: `${require("img/EcosphereDetails/Trainicon02.png")} 1x,${require("img/EcosphereDetails/Trainicon02@2x.png")} 2x,${require("img/EcosphereDetails/Trainicon02@3x.png")} 3x`
        },
        {
          title: '公开课',
          data: '我们甄选课程，供您借鉴、交流、研讨。融合工程管理业内前沿的科学技术与先进的管理理念、企业高管的成功经验、知名教授的思想精髓，从理论学习到实战演练，再到行为改变，全方位、多角度助力学员完成思想与专业知识的转型与升级。',
          imgPath: require("img/EcosphereDetails/Trainicon03.png"), imgHDPath: `${require("img/EcosphereDetails/Trainicon03.png")} 1x,${require("img/EcosphereDetails/Trainicon03@2x.png")} 2x,${require("img/EcosphereDetails/Trainicon03@3x.png")} 3x`
        }
      ],
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="Train">
          <h5 className='product-title'>服务介绍</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
        </div>
      </main>
    )
  }
}
export default Train
